import React from 'react'
import { Link, useLocation } from 'react-router-dom'

const SecretPublicFooter: React.FC = () => {
  const location = useLocation()
  const isSecretRoot = location.pathname === '/'
  
  return (
    <footer className="relative z-10 border-t border-white/20 py-8 px-4 sm:px-6 lg:px-8 bg-black/20 backdrop-blur-sm">
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-white/80 text-sm">
          © 2025 Tailtations LLC - All rights reserved.
        </p>
        <p className="text-white/60 text-xs mt-2">
          {isSecretRoot ? (
            <>
              <a href="https://tailtations.com" className="hover:text-primary transition-colors">Visit Tailtations Home</a>
              {' | '}
              <Link to="/terms-of-use" className="hover:text-primary transition-colors">Terms</Link>
              {' | '}
              <Link to="/privacy-policy" className="hover:text-primary transition-colors">Privacy</Link>
            </>
          ) : (
            <>
              <Link to="/" className="hover:text-primary transition-colors">Home</Link>
              {' | '}
              <Link to="/terms-of-use" className="hover:text-primary transition-colors">Terms</Link>
              {' | '}
              <Link to="/privacy-policy" className="hover:text-primary transition-colors">Privacy</Link>
            </>
          )}
        </p>
      </div>
    </footer>
  )
}

export default SecretPublicFooter